import React from 'react';
import { Instagram } from 'lucide-react';

export const InstagramSection = () => (
  <section className="py-20 px-6 bg-silver-900/5" data-testid="instagram-section">
    <div className="container mx-auto">
      <h2 className="text-4xl md:text-5xl font-black mb-12 text-center">
        <span className="text-white">Follow </span>
        <span className="text-silver-400">@RhodiumRecordsMusic</span>
      </h2>

      <div className="max-w-4xl mx-auto">
        <div className="bg-silver-900/10 border border-silver-400/20 rounded-2xl p-8">
          <div className="aspect-square max-w-xl mx-auto mb-6">
            <iframe
              title="Rhodium Records Instagram"
              src="https://www.instagram.com/rhodiumrecordsmusic/embed"
              className="w-full h-full rounded-lg"
              frameBorder="0"
              scrolling="no"
              style={{ background: 'white' }}
            />
          </div>
          <div className="text-center">
            <a
              href="https://www.instagram.com/rhodiumrecordsmusic/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-silver-400 hover:bg-silver-300 text-black font-bold text-sm uppercase tracking-wider rounded-lg transition-all duration-300 hover:scale-105"
            >
              <Instagram size={20} />
              Follow on Instagram
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
